import { marked } from "marked";
import DOMPurify from "dompurify";
import { messageContentToText } from "@/lib/chatHistoryLimits";

marked.setOptions({
  gfm: true,
  breaks: true,
});

export function renderMarkdownToHtml(content: string | unknown): string {
  const text = messageContentToText(content);
  try {
    const html = marked.parse(text, { async: false }) as string;
    return DOMPurify.sanitize(html);
  } catch (error) {
    console.error("Error rendering markdown:", error);
    return DOMPurify.sanitize(text);
  }
}

/**
 * Copies markdown content to the clipboard with both `text/html` (rendered)
 * and `text/plain` (clean stripped text) MIME types. Rich editors like Word
 * will paste formatted text; plain editors like Notepad get clean text.
 */
export async function copyFormattedContent(markdown: string): Promise<void> {
  const html = renderMarkdownToHtml(markdown);

  const temp = document.createElement("div");
  temp.innerHTML = html;
  const plainText = temp.innerText;

  const clipboardItem = new ClipboardItem({
    "text/html": new Blob([html], { type: "text/html" }),
    "text/plain": new Blob([plainText], { type: "text/plain" }),
  });
  await navigator.clipboard.write([clipboardItem]);
}
